import { useDispatch } from 'react-redux';
import { selectMode, setActiveSectionId, setView } from '../../../store/appSlice';
import { Id } from '../../../types';
import { ChordButtonAddon, ChordButtonAddonShape, StyledAddChordButton } from './styles';
import useSectionHasChords from '../../../hooks/useSectionHasNoChords';
import { useAppSelector } from '../../../global/hooks';
import useHasExceededChordLimit from '../../../hooks/useHasExceededChordLimit';

export default function AddChordButton({ sectionId }: { sectionId: Id }) {
	const mode = useAppSelector(selectMode);
	const dispatch = useDispatch();

	const canAddChords = !useHasExceededChordLimit(sectionId);
	const addChord = () => {
		if (canAddChords) {
			dispatch(setView('editChord'));
			dispatch(setActiveSectionId(sectionId));
		} else {
			// @TODO warning modal
			console.warn("You've reached the maximum number of chords for this section");
		}
	};
	const doesSectionHaveChords = useSectionHasChords(sectionId);

	return mode === 'edit' ? (
		<StyledAddChordButton
			className="add-chord-button"
			onClick={addChord}
			doesSectionHaveChords={doesSectionHaveChords}
			title={
				canAddChords
					? 'Add chord'
					: 'You have reached the maximum number of chords for this section'
			}
		>
			+{' '}
			{!doesSectionHaveChords && (
				<ChordButtonAddon>
					<ChordButtonAddonShape />
					Add Chord
				</ChordButtonAddon>
			)}
		</StyledAddChordButton>
	) : null;
}
